// Company Check-Identifier ***********************************************************************
// pathname: /v1/company/check-identifier/{value}
// ************************************************************************************************
import { useSwrApi } from 'src/hooks/useSwrApi';

/** Interface */
interface SwrCompanyCheckIdentifier {
  locale: string;
  identifier?: string;
  successCallback?: (data: ApiSchema<'IdentifierCheckResponse'>) => void;
}

/**
 * @description SWR: get company details by identifier
 * - **locale** - The locale to use for the request
 * - **identifier** - The identifier to search for. If not provided, the request will not be made.
 */
export const useSwrCompanyCheckIdentifier = (props: SwrCompanyCheckIdentifier) => {
  // Destructure props
  const {
    locale,
    identifier,
    successCallback,
  } = props;

  // SWR
  const {
    data,
    error,
    isValidating,
    isLoading,
    mutate,
  } = useSwrApi<ApiSchema<'IdentifierCheckResponse'>>({
    url: `/v1/company/check-identifier/${identifier}`,
    locale,
    shouldFetch: !!identifier,
    apiOptions: {
      dedupingInterval: 60 * 1000 * 60, // 1 hour
      revalidateOnFocus: false,
      onSuccess: (newData) => {
        if (successCallback) {
          void successCallback(newData);
        }
      },
    },
  });

  // Return data
  return {
    data,
    error,
    isValidating,
    isLoading,
    mutate,
  };
};
